import { toast } from "sonner";
import { StatusChip } from "../../components/data/StatusChip";
import { RowActions } from "../../components/data/RowActions";
import { localName } from "../../lib/localName";

// أعمدة جدول الموردين: المورد · التصنيف · الهاتف · الرصيد · الحالة · الإجراءات.
export const supplierColumns = ({ t, i18n, onOpen, onArchive }) => [
  { key: "supplier", label: t("purchases.cols.supplier"),
    render: (row) => (
      <span className="block max-w-[240px] truncate text-xs font-bold">
        {localName(row)}
        <span className="num block font-mono text-[10px] text-muted-foreground">
          {row.code || "—"}
        </span>
      </span>
    ) },
  { key: "currency", label: t("purchases.cols.currency"),
    render: (row) => <span className="num font-mono text-[11px] text-primary">{row.currency}</span> },
  { key: "trn", label: t("purchases.trn"),
    render: (row) => (
      <span className="num font-mono text-[11px]">{row.tax?.trn || "—"}</span>
    ) },
  { key: "phone", label: t("purchases.phone"),
    render: (row) => <span className="num font-mono text-[11px]" dir="ltr">{row.phone || "—"}</span> },
  { key: "terms", label: t("purchases.paymentTerms"),
    render: (row) => (
      <span className="num text-[11px] text-muted-foreground">
        {t("purchases.netDays", { days: row.payment_terms_days })}
      </span>
    ) },
  { key: "state", label: t("purchases.cols.state"),
    render: (row) => <StatusChip state={row.is_archived ? "archived" : "active"}
                                 labelKey="purchases.supplierStates" /> },
  { key: "actions", label: t("purchases.cols.actions"),
    render: (row) => (
      <RowActions
        testid={`supplier-actions-${row.id}`}
        actions={[
          { key: "view", title: t("purchases.cols.view"), onClick: () => onOpen(row) },
          { key: "delete", title: t("app.delete"), disabled: row.is_archived,
            onClick: () => onArchive(row).catch(() => toast.error(t("errors.generic"))) },
        ]}
      />
    ) },
];
